import { type ThemeProps } from '@kijiji/theme'
import styled from 'styled-components'

import { Badge } from '@/ui/atoms/badge'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const GallerySingleItemContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

export const GallerySingleItemViewport = styled.div`
  overflow: hidden;
  height: 100%;
`

export const GallerySingleItemList = styled.ul(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  height: 100%;

  ${MEDIA_QUERIES(theme).medium}{
    padding: 0;
  }
`
)

export const GallerySingleItemSlide = styled.li(
  ({ theme }) => `
    background-color: ${theme.colors.white};
    display: flex;
    flex: 0 0 auto;
    max-width: 100%;
    width: 100%;

    & > div {
      width: 100%;
    }
  `
)

export const GalleryCountBadge = styled(Badge)(
  ({ theme }) => `
  position: absolute;
  bottom: ${theme.spacing.defaultSmall};
  right: ${theme.spacing.defaultSmall};
`
)

export const GalleryDotsContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`

export const GalleryDotsViewport = styled.div`
  max-width: 5rem;
  margin: 0 auto;
  overflow: hidden;
`

type GalleryDotsWrapperProps = {
  theme: ThemeProps
  $transformValue: number
  $centerDots: boolean
}

export const GalleryDotsWrapper = styled.div(
  ({ theme, $transformValue, $centerDots }: GalleryDotsWrapperProps) => `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.mini};
  margin: ${theme.spacing.defaultSmall} 0;
  transform: translate(${$transformValue}rem);
  transition: transform 0.3s ease;
  justify-content: ${$centerDots ? 'center' : 'flex-start'}
  `
)

type GalleryDotProps = {
  isSelected: boolean
}

// eslint-disable-next-line @kijiji/prefer-button-component
export const GalleryDot = styled.button<GalleryDotProps>(
  ({ theme, isSelected }) => `
    align-items: center;
    display: flex;
    height: ${theme.spacing.large};

    &:after {
      background-color: ${theme.colors.white};
      opacity: ${isSelected ? 1 : 0.5};
      border-radius: ${theme.borderRadius.rounded};
      box-sizing: border-box;
      content: '';
      height: 0.6rem;
      width: 0.6rem;
    }
  `
)
